import { IReportingPeriodFormType } from "../../reporting/ReportingPeriodFormType";
import { DateService } from "../../../service/DateService";

export interface TReportingPeriodFormTypePresentationModel {
  id: number;
  formName: string;
  formReportingPeriodId: string;
  currentVersion: string;
  status: string;
  dateOfLastChange?: string;
  sendDate?: string;
  formTypeStatus: string;
  addNewDraftVersionLoader?: boolean;
}

const ReportingPeriodFormTypePresentationModel = (
  data: IReportingPeriodFormType,
  isPreviousForms?: boolean,
  translate?: any
) => {
  const dateOfLastChange = data.dateOfLastChange
    ? DateService().formatDate(data.dateOfLastChange)
    : undefined;
  const sendDate = data.sendDate
    ? DateService().formatDate(data.sendDate)
    : undefined;

  return {
    id: data.id,
    formName: data.formName,
    formReportingPeriodId: data.formReportingPeriodId,
    currentVersion:
      !data.currentVersion && isPreviousForms
        ? translate("reports_page.form_types_datagrid.no_active_version")
        : data.currentVersion,
    status: data.status,
    dateOfLastChange: dateOfLastChange,
    sendDate: sendDate,
    formTypeStatus: data.formTypeStatus
  };
};

export default ReportingPeriodFormTypePresentationModel;
